import { Dispatch } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { Link, useLocation, useNavigate } from 'react-router';
import classNames from 'classnames';
import { Action } from 'redux';

import { RootState } from '../../../../lib/store';
import { switchAccount } from '../../../../lib/store/crm';
import { hasAccountPaidAndDemoPlan } from '../../../../lib/store/crm/helpers';
import { FeatureFlags } from '../../../../lib/util/flags/types';

import { useFlags } from '../../../../hooks';
import { HeaderDropdownItem, MyProfileOptions } from '../../Header.types';

import { icons } from './MyProfile.constants';

import styles from './MyProfile.module.scss';

type Props = {
  dropdownItemsMyProfile: HeaderDropdownItem[];
  dropDownItem: string | null;
  handleClickBtnDropDown: () => void;
  setIsSwitchingOtherAccount: Dispatch<React.SetStateAction<boolean>>;
  openChangePasswordModal: () => void;
} & ReduxProps;

const MyProfile = (props: Props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const flags = useFlags([ FeatureFlags.referrals ]);

  const {
    dropdownItemsMyProfile,
    dropDownItem,
    isUseDemoAccount,
    openChangePasswordModal,
    handleClickBtnDropDown,
    switchToAccount,
    hasPaidAndDemoPlan,
    setIsSwitchingOtherAccount,
  } = props;

  const handleClick = (dropdownItem, event) => {
    if (dropdownItem.id === MyProfileOptions.CHANGE_PLAN) {
      event.preventDefault();
      setIsSwitchingOtherAccount(true);
      switchToAccount(!isUseDemoAccount);
      handleClickBtnDropDown();
      return;
    }

    if (dropdownItem.id === MyProfileOptions.CHANGE_PASSWORD) {
      event.preventDefault();
      openChangePasswordModal();
      handleClickBtnDropDown();
      return;
    }

    if (dropdownItem.id === MyProfileOptions.LOG_OUT) {
      dropdownItem.action();
      return;
    }

    handleClickBtnDropDown();
  };
  return (
    <div className={styles.dropdownMenuItemsContainer}>
      {dropdownItemsMyProfile.map((dropdownItem: HeaderDropdownItem, index) => (
        <div
          key={dropdownItem.text}
          className={dropdownItem.text === dropDownItem ? styles.btnBackground : ''}
        >
          <div
            className={classNames(styles.dropdownMenuItemContainer, {
              [styles.border]: index === dropdownItemsMyProfile.length - 1,
            })}
          >
            <div
              className={classNames(styles.wrapperRow, {
                [styles.changeAccountRow]: dropdownItem.id === MyProfileOptions.CHANGE_PLAN,
              })}
            >
              <img
                className={dropdownItem.isDisabled ? styles.disabledIcon : ''}
                src={icons(hasPaidAndDemoPlan, flags[FeatureFlags.referrals].enabled)[index]}
                alt="icon my profile"
              />
              <Link
                id={`profile_option_${index}`}
                aria-label={`my profile option ${dropdownItem.text}`}
                to={dropdownItem.link}
                state={{
                  ...(location.state as object),
                  dropDownItem: dropdownItem.text,
                  pathname: location.pathname,
                }}
                className={
                  dropdownItem.isDisabled
                    ? styles.disabledDropdownMenuItemsText
                    : styles.dropdownMenuItemsText
                }
                onClick={(event) => handleClick(dropdownItem, event)}
              >
                {dropdownItem.text}
              </Link>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  isUseDemoAccount: state.crm.isUseDemoAccount,
  hasPaidAndDemoPlan: hasAccountPaidAndDemoPlan(state.crm),
});

const mapDispatchToProps = (dispatch: Dispatch<Action>) => ({
  switchToAccount: (toDemo: boolean) => dispatch(switchAccount(toDemo)),
});

const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;

export default connector(MyProfile);
